module.exports = __webpack_public_path__ + "img/36.97693528.jpg";